import { each, assign } from 'lodash';
import { ToastProgrammatic } from 'buefy';
import { BaseUIService } from '/@/modules/core/ui/services/BaseUIService';
import type { App } from 'vue';

let toastInstance: ToastProgrammatic | null = null;

type ToastOptions = {
  type?: string;
  message?: string;
  position?:
    | 'is-top-right'
    | 'is-top'
    | 'is-top-left'
    | 'is-bottom-right'
    | 'is-bottom'
    | 'is-bottom-left';
  duration?: number;
  container?: string;
  queue?: boolean;
};

export class ToastService extends BaseUIService {
  setApp(app: App): void {
    toastInstance = new ToastProgrammatic(app);
  }

  show(messages: string | string[], options: ToastOptions = {}): void {
    options.type = 'is-dark';
    options.duration = options.duration ?? 4000;
    if (!(messages instanceof Array)) {
      messages = [messages];
    }
    each(messages, (message: string) => {
      if (!toastInstance) {
        throw new Error('ToastService: app not initialized. Call setApp() first.');
      }
      toastInstance.open(assign(options, { message }));
    });
  }
}

export default new ToastService();
